import * as React from 'react';
import * as classNames from 'classnames';
import {isMobile} from '../../utils/helpers';
import {NavTab} from './nav-tab';
import {NavTabControls} from './nav-tab-controls';
import {NavTabPanel} from './nav-tab-panel';
import {NavTabsMeasure} from './nav-tabs-measure';

interface IProps {
  className?: string;
  children?: any;
}

interface IState {
  selectedIndex?: number;
  width?: number;
}

export class NavTabs extends React.Component<IProps, IState> {
  public state: IState = {
    selectedIndex: 0,
    width: 0,
  };

  public render(): React.ReactElement<{}> {
    const {selectedIndex, width} = this.state;
    const {cloneElement} = React;
    const {className} = this.props;

    const tabs = this.children((child, index) => (
      <NavTab
        name={child.props.title}
        isActive={(index === selectedIndex)}
        onSelect={() => this.onSelect(index)}
      />
    ));

    const panels = this.children( (child, index) => {
      return cloneElement(child, {isActive: (index === selectedIndex)});
    });

    return (
      <NavTabsMeasure onResize={this.onResize}>
        <div className={classNames('nav-tabs', className)}>
          {(!isMobile() || tabs.length > 1) &&
              <NavTabControls width={width}>{tabs}</NavTabControls>
          }

          {panels}

          <div className='nav-tab-footer'></div>
        </div>
      </NavTabsMeasure>
    );
  }

  private children(fn: (child: any, index?: number) => any): any {
    return React.Children.map(this.props.children, (child: any, index: number) => {
      if (NavTabPanel !== child.type) {
        throw 'NavTabs accepts as child element only NavTabPanel';
      }

      return fn(child, index);
    });
  }

  private onResize = (width) => {
    this.setState({width});
  };

  private onSelect = (selectedIndex: number) => {
    this.setState({selectedIndex});
  };
}
